import { getProvinceListByDepartmentIdRequest } from "../../data/provinceApi";

function getPayloadData(response) {
  if (Array.isArray(response)) {
    return response;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  if (Array.isArray(response?.data?.data)) {
    return response.data.data;
  }

  return [];
}

export async function getProvinceListByDepartmentIdUseCase(departmentId) {
  if (!departmentId) {
    throw new Error("El id del departamento es obligatorio.");
  }

  return getPayloadData(await getProvinceListByDepartmentIdRequest(departmentId));
}
